/**
 * authService.js — llamadas de autenticación al backend.
 *
 * Login:   POST /api/core/login/
 * Perfil:  GET  /api/residents/perfil/
 */

import apiFetch from "../../../shared/services/apiClient";

const BASE_URL = process.env.REACT_APP_API_URL ?? "";

export async function loginRequest(username, password) {
  const res = await fetch(`${BASE_URL}/api/core/login/`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ username, password }),
  });

  if (!res.ok) {
    const data = await res.json().catch(() => ({}));
    throw new Error(data?.detail ?? "Credenciales inválidas.");
  }

  return res.json();
}

export async function getProfile() {
  // El perfil se expone en /api/residents/perfil/ (PerfilViewSet registrado ahí)
  const res = await apiFetch("/api/residents/perfil/");
  if (!res.ok) throw new Error("No se pudo cargar el perfil.");
  return res.json();
}
